import history from '../history'

var RoutingUtils = {

    push: (hash) => {
        history.push(hash)
    }

}

export default RoutingUtils
